/**
* @description warstwa pokazująca html, alerty, potykacze
* @module modal
*/
app.service('modal',function($global, console, loading, broker, front, focusTrap, activeElement){
	var alertModal=false;
	var alertCallback=false;
	var messageModal=false;
	var messages=[];
	var modalsCallbackClose=[];

	function setActiveElement(){
		activeElement.set();
	}
	function focusActiveElement(){
		let element = activeElement.get();
		if(element){
			element.focus();
			console.log('Po zamknięciu modala focusowany element', element);
		} else {
			console.log('Brak elementu do focusowania po zamknięciue');
		}
	}

	/**
	* @function open
	* @description wyświetla warstwę
	* @param {text} id identyfikator warstwy
	*/
	function open(id, params){
		if(isExist(id)){
			setActiveElement();
			var defaults={
				hashTracking: false
			};
			var $modal = $('[data-remodal-id='+id+']').filter('.remodal');
			if ($modal.length) { // przypadek gdy w kodzie na nowo pojawia sie ten sam modal, to usuwamy ten wstepnie wygenerowany, a otwieramy juz otwarty; usuwanie tylko dla przypadku istnienia modali z klasą .remodal (inaczej usuna sie wszystkie)
				$modal.filter(':not(.remodal)').remove();
			}
			console.log('otwieramy warstwę: ' + id);
			var modal = $('[data-remodal-id='+id+']').remodal($.extend(true,defaults,params));
			loading.stop();
			modal.open();
			if(params && params.callbackClose){
				modalsCallbackClose[id] = function(){
					params.callbackClose();
					focusActiveElement(); // do zweryfikowania czy nie potrzebny jest głębiej, w ramach callbackClose()
				}
			}
			logModalHistoryState();
			return modal;
		}else{
			console.log('NIE ISTNIEJE MODAL');
		}
	}
	/**
	* @function alert
	* @description wyświetla warstę z przekazanym tekstem i guzukiem OK
	* @param {text} text tekst do pokazania
	*/
	function alert(text, callback){
		if(typeof(text)==='object'){
			$result=$('<ul/>');
			text.forEach(function(a,i){
				$result.append($('<li/>').text(a));
			})
			$('#alert p').html($result);
		}else{
			$('#alert p').html(text);
		}
		alertCallback=callback || false;
		loading.stop();
		$(window).trigger('loadingStop');
		alertModal.open();
	}
	function close(id){
		var $modal = $('.remodal-is-opened .remodal');
		if ($modal.length){
			focusTrap.reset();
			$modal.remodal().close();
			focusActiveElement();
		}
		alertCallback = false;
	}
	function callbackClose($modal, callback){
		$modal['$modal'].on('click', '.remodal-close', function(){
			callback();
		});
	}
	/**
	 * @function isExist
	 * @description sprawdza czy warstwa o podanym id istnieje
	 * @param {text} id identyfikator warstwy
	 */
	function isOpen(id){
		if(isExist(id)){
			return $('[data-remodal-id='+id+']').remodal().getState()=='opened';
		}
		return false;
	}
	function isExist(id){
		return $('[data-remodal-id='+id+']').length ? true : false;
	}
	function destroy(id){
		try{
			$('.remodal-wrapper [data-remodal-id='+id+']').remodal().destroy();
		}catch(e){}
	}
	/**
	* @function removeRemodals
	* @description usuwa wszystkie modale poza tymi, które umieszczono w $safeModals
	*/
	function removeRemodals() {
		clearMessages();
		const $safeModals = $('#alert, #message'); //id modali, które nie zostaną usunięte
		const $modalsToRemove = $('.remodal').not($safeModals);
		if ($modalsToRemove.length) {
			$modalsToRemove.each(function () {
				destroy($(this).data('remodalId'))
			})
		}
		broker.trigger('REMOVE_ALL_MODALS');
	}
	/**
	* @function generate
	* @description generuje warstę z przekazanymi danymi
	*/
	function addMessage(text, cssClass=''){
		messages.push({ text, cssClass });
	}
	function showMessages() {
		if(messages.length) {
			var message = messages.shift();
			$('#message p').attr('class', message.cssClass).html(message.text);
			messageModal.open();
		}
	}
	function discardMessage() {
		setTimeout(function() {
			showMessages();
		}, 2000);
	}
	function clearMessages() {
		messages = [];
	}
	function generate(params){
		var options={
			content:null,
			header:null,
			modifier:null,
			callbackOpen:null,
			callbackClose:null,
			closeOnEscape:true,
			close:true,
			show:true,
			id:null,
			overwrite:true,
			hashTracking: false,
			buttons:{}
		};
		$.extend(true, options, params);
		if(options.overwrite && options.id){
			$('[data-remodal-id='+options.id+']').parent().remove();
		}
		setActiveElement();
		var $html=$('<div class="remodal"></div>');
		if(options.id){
			$html.attr('id',options.id);
			$html.attr('data-remodal-id',options.id);
		} else {
			//gdy brak id, wygeneruj w formacie modal-(1 - 999999)
			options.id = 'modal-' + (Math.floor(Math.random() * (999999 - 1)) + 1);
			$html.attr('id',options.id);
			$html.attr('data-remodal-id',options.id);
		}
		if(options.cssClass){
			$html.addClass(options.cssClass);
		}
		if(options.close){
			var closeButton=$('<button data-remodal-action="close" class="remodal-close" aria-label="Zamknij okno dialogowe"></button>');
			$html.append(closeButton);
		}
		if(options.header){
			$html.append('<h2>'+options.header+'</h2>');
		}
		if(options.content){
			$html.append(options.content);
		}
		if(options.buttons.length){
			var buttons=$('<div class="buttons"/>');
			$(options.buttons).each(function(i,n){
				var button=$('<button/>');
				if(n.text){
					button.text(n.text);
				}
				if(n.cssClass){
					button.addClass(n.cssClass);
				}
				if(n.click){
					button.click(function(){
						n.click();
					});
				}
				buttons.append(button).addClass('buttons-'+options.buttons.length);
			});
			$html.append(buttons);
		}
		$('body').append($html);
		var modalHandler=$html.remodal({
			hashTracking: false,
			modifier: options.modifier,
			closeOnEscape: !(options.closeOnEscape===false || options.close===false),
			closeOnOutsideClick: options.close
		});
		if(options.show){
			loading.stop();
			modalHandler.open();
			logModalHistoryState();
		}
		if(options.callbackOpen){
			options.callbackOpen.call(modalHandler);
		}
		$(document).on('closed', $html, function (e) {
			focusTrap.reset();
			if(options.id === $(e.target).attr('id')) {
				if(options.callbackClose){
					options.callbackClose(e);
				}
				focusActiveElement();
			}
		});
		return modalHandler;
	}
	function setElements() {
		alertModal=generate({
			cssClass:'alert-modal',
			id:'alert',
			show:false,
			content:'<p></p><button data-remodal-action="confirm" class="btn btn-second">Ok</button>'
		});
		$(document).on('closed', alertModal, function (e) {
			if(alertCallback){
				alertCallback();
			}
		});
		$(document).on('closed', function (e) {
			if(modalsCallbackClose[e.target.dataset.remodalId]){
				modalsCallbackClose[e.target.dataset.remodalId]();
			}
		});
		messageModal=generate({
			cssClass:'message-modal',
			id:'message',
			show:false,
			content: '<p></p><button data-remodal-action="confirm" class="btn btn-second js-discard-message">Ok</button>'
		});
	}
	function setEvents(){
		$('body').on('click','.close-modal, .js-close-modal',function(event){
			close();
		}).on('click','button[data-remodal-action=close]',function(event){
			focusActiveElement(); // do zweryfikowania przez PGR dla jakich sytuacji tego potrzebujemy
		});

		$(document).on('opened', '.remodal', function () {
			var text = '';
			var $title = $(this).find('h2:eq(0)');

			if($title && $title.text()!=''){
				text = $title.text();
			}else{
				text = $(this).text();
			}
			focusTrap.set($(this));
			eventLog({
				id: $(this).data('remodal-id'),
				content: text.replace(/[\t\n\r]/g,'').substr(0,50) //v2 - patrz komentarz wyżej
			});
		});

		$(document).on('closing', '#message', function () {
			discardMessage();
		});

		if(!front.isAjaxPageEnabled()) {
			$(document).on('closing', '.remodal', function (e) {
				if (location.hash == '#modalState') {
					window.history.back();
				}
			});

			$(window).on('popstate', function (event) {  //pressed back button
				if (event.state !== null) { //    zamykam modala na powrot mobile button
					close();
				}
			});
		}


	}

	function eventLog(options){
		app.logEvent({
			id:'fancybox',
			f03: document.location.href,
			f04: options.id,
			f05: options.content,
			// f04: (options.href?options.href.replace(/\s/g, ''):'inline'), //oryginalne z desktopa
			// f05: (!options.href?$.trim($(options.content).text()).substr(0,50):'') //oryginalne z desktopa
		});
	}

	function logModalHistoryState () {
		if (!front.isAjaxPageEnabled()) {
			window.history.pushState('modalForwad', 'ModalState');
		}
	}

	function init(){
		setElements();
		setEvents();
	}
	$global('showModal', generate);
	$global('closeModal', close);
	$(document).ready(function(){
		init();
		showMessages();
	});
	$global('alert',alert);
	$global('addMessage',addMessage);
	return {
		open:open,
		alert:alert,
		addMessage:addMessage,
		showMessages:showMessages,
		clearMessages:clearMessages,
		generate:generate,
		close:close,
		callbackClose:callbackClose,
		isOpen: isOpen,
		isExist: isExist,
		destroy: destroy,
		removeRemodals: removeRemodals
	};
});
